<template v-loading="loading">
  <el-form :model="post" ref="postsEdit">

    <ubi-page-container class="PostEdit">
      <template v-slot:page-tabs>
        <el-tabs v-model="currentTab" type="card">
          <el-tab-pane v-for="tab in tabs"
                       :key="tab.name"
                       :label="tab.title"
                       :name="tab.name"
                       :disabled="tab.disabled"
          >
          </el-tab-pane>
        </el-tabs>
      </template>

      <div v-for="(tab, index) in tabs" :key="index">
        <div v-if="post" v-show="currentTab === tab.name">
          <ManagePostNetwork
              :currentTab="currentTab"
              :post="post"
              :networkName="tab.name"
              :fromNewPost="fromNewPost"
              :title-h3="tab.titleH3"
              :title-h4="tab.titleH4"
              :titleH3Info="tab.titleH3Info"
              :textAsideInfo1="tab.textAsideInfo1"
              :textAsideInfo2="tab.textAsideInfo2"
              :titleWarning="tab.titleWarning"
              :textWarning="tab.textWarning"
              :text-aside="tab.textAside"
              :textInfoTextarea1="tab.textInfoTextarea1"
              :textInfoTextarea2="tab.textInfoTextarea2"
              :textInfoIA="tab.textInfoIA"
              :networkEvent="getEventsAnnonce"
              :not-activated="tab.notActivated"
              :action-enregistrer="tab.analyticsEnregistrer"
              :action-annuler="tab.analyticsAnnuler"
              :possede-r-s="tab.possedeRS"
              :getCaption="tab.name === 'Video' ? '' : getCaptionsBYNetwork"
              @change-tab="updateCurrentTab"
          >
          </ManagePostNetwork>
        </div>
      </div>
    </ubi-page-container>
  </el-form>

</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { getPostById } from '@/services/posts'
import { Tabs, TabPane } from 'element-ui'
import ManagePostNetwork from '@/pages/posts/SocialNetworkPosts/ManagePostNetwork.vue'
import UbiPageContainer from '@/components/PageContainer.vue'
import { getDiffuseur } from '@/helpers/functions/diffuseur'

export default {
  name: 'ManagePosts',
  components: {
    UbiPageContainer,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ManagePostNetwork
  },
  inject: ['browserContext'],
  data () {
    return {
      post: null,
      currentType: null,
      currentTab: 'Video',
      captionLength: 0,
      checkHashtags: 0,
      checkArobase: 0,
      checkDiffusee: false,
      disableInsta: false,
      generatedCaption: '',
      generatedCaptionGMB: '',
      loading: false,
      fromNewPost: false,
      tabs: [
        {
          name: 'Video',
          title: 'Flow vidéo',
          active: true,
          titleH3: this.$t('posts.clap.toKnowTitle'),
          textAside: this.$t('posts.clap.toKnowText'),
          titleH4: this.$t('posts.clap.informationTitle'),
          notActivated: this.$t('posts.clap.informationTitle')
        },
        {
          name: 'Instagram',
          title: 'Instagram',
          titleH3: this.$t('posts.networks.instagram.asideTitle'),
          textAside: this.$t('posts.networks.instagram.asideText'),
          titleH3Info: this.$t('posts.networks.instagram.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.instagram.asideInfoText1'),
          titleWarning: this.$t('posts.networks.instagram.titleWarning'),
          textWarning: this.$t('posts.networks.instagram.textWarning'),
          titleH4: this.$t('posts.networks.instagram.titleTextarea'),
          textInfoTextarea1: this.$t('posts.networks.instagram.textInfoTextarea1'),
          textInfoTextarea2: this.$t('posts.networks.instagram.textInfoTextarea2'),
          textInfoIA: this.$t('posts.networks.instagram.textInfoIA'),
          analyticsEnregistrer: 'enregistrer_instagram',
          analyticsAnnuler: 'annuler_instagram',
          possedeRS: false
        },
        {
          name: 'Facebook',
          title: this.$t('Facebook'),
          titleH3: this.$t('posts.networks.facebook.asideTitle'),
          textAside: this.$t('posts.networks.facebook.asideText'),
          titleH3Info: this.$t('posts.networks.facebook.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.facebook.asideInfoText1'),
          titleWarning: this.$t('posts.networks.facebook.titleWarning'),
          textWarning: this.$t('posts.networks.facebook.textWarning'),
          titleH4: this.$t('posts.networks.facebook.titleTextarea'),
          textInfoTextarea1: this.$t('posts.networks.instagram.textInfoTextarea1'),
          textInfoTextarea2: this.$t('posts.networks.instagram.textInfoTextarea2'),
          textInfoIA: this.$t('posts.networks.facebook.textInfoIA'),
          analyticsEnregistrer: 'enregistrer_facebook',
          analyticsAnnuler: 'annuler_facebook',
          possedeRS: false
        },
        {
          name: 'Google',
          title: this.$t('Google Business Profile'),
          titleH3: this.$t('posts.networks.google.asideTitle'),
          textAside: this.$t('posts.networks.google.asideText'),
          titleH3Info: this.$t('posts.networks.google.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.google.asideInfoText1'),
          titleWarning: this.$t('posts.networks.google.titleWarning'),
          textWarning: this.$t('posts.networks.google.textWarning'),
          titleH4: this.$t('posts.networks.google.titleTextarea'),
          textInfoTextarea1: this.$t('posts.networks.instagram.textInfoTextarea1'),
          textInfoTextarea2: this.$t('posts.networks.instagram.textInfoTextarea2'),
          textInfoIA: this.$t('posts.networks.google.textInfoIA'),
          analyticsEnregistrer: 'enregistrer_gmb',
          analyticsAnnuler: 'annuler_gmb',
          possedeRS: false
        },
        {
          name: 'LinkedIn',
          title: this.$t('LinkedIn'),
          titleH3: this.$t('posts.networks.linkedin.asideTitle'),
          textAside: this.$t('posts.networks.linkedin.asideText'),
          titleH3Info: this.$t('posts.networks.linkedin.asideInfoTitle'),
          textAsideInfo1: this.$t('posts.networks.linkedin.asideInfoText1'),
          titleWarning: this.$t('posts.networks.linkedin.titleWarning'),
          textWarning: this.$t('posts.networks.linkedin.textWarning'),
          titleH4: this.$t('posts.networks.linkedin.titleTextarea'),
          textInfoTextarea1: this.$t('posts.networks.instagram.textInfoTextarea1'),
          textInfoTextarea2: this.$t('posts.networks.instagram.textInfoTextarea2'),
          textInfoIA: this.$t('posts.networks.linkedin.textInfoIA'),
          analyticsEnregistrer: 'enregistrer_linkedin',
          analyticsAnnuler: 'annuler_linkedin',
          possedeRS: false
        }
      ],
      currentEvent: ''
    }
  },
  methods: {
    ...mapMutations('posts', [
      'setPost'
    ]),
    updateCurrentTab (tabName) {
      this.currentTab = tabName
    },
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    changeRedirect (value) {
      this.redirect = value
    },
    formatPostBooleanValues (post) {
      const newPost = {}
      for (const property in post) {
        if (post[property] === true) {
          newPost[property] = 'oui'
        } else if (post[property] === false) {
          newPost[property] = 'non'
        } else {
          newPost[property] = post[property]
        }
      }
      this.post = newPost
    },
    checkCaptionLength () {
      this.captionLength = this.generatedCaption.length
      this.checkHashtags = this.generatedCaption.replace(/[^#]/g, '').length
      this.checkArobase = this.generatedCaption.replace(/[^@]/g, '').length
    }
  },
  computed: {
    ...mapState('posts', ['filter']),
    ...mapGetters('calendarSocialPosts', ['getListEventsByAnnonceByNetwork']),
    ...mapGetters('caption', ['getCaptionByNetwork']),
    ...mapGetters('storeClap', ['getHasPost', 'getListPostsClap', 'getPostClap', 'getHasUrlClap']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    possedeInstagram () {
      return this.user.possedeInstagram
    },
    possedeGMB () {
      return this.user.haveGMB
    },
    possedeFacebook () {
      return this.user.haveFacebook
    },
    possedeLinkedIn () {
      return this.user.haveLinkedIn
    },
    getEventsAnnonce () {
      return this.getListEventsByAnnonceByNetwork(this.currentTab)
    },
    getCaptionsBYNetwork () {
      if (this.currentTab === 'Video' || this.currentTab === 'Home') {
        return
      }
      const diffuseur = getDiffuseur(this.currentTab, this.universe, false)
      return this.getCaptionByNetwork(diffuseur, this.$route.params.id)
    },
    hasPostClapVideo () {
      return this.getHasPost(this.post)
    },
    getHasUrlClapVideo () {
      return this.getHasUrlClap(this.$route.params.id)
    }
  },
  mounted () {
    if (this.$route.query.network && !this.$route.query.bienVendu) {
      const redirectTab = this.tabs.filter((tab) => tab.name.toUpperCase() === this.$route.query.network.toUpperCase())
      this.currentTab = redirectTab[0].name
    }
    this.$store.dispatch('calendarSocialPosts/loadEventsByAnnonce', this.$route.params.id)
    this.$store.dispatch('diffuseurs/loadDiffuseurs')
  },
  beforeMount () {
    this.loading = true
    this.tabs[1].possedeRS = this.possedeInstagram
    this.tabs[2].possedeRS = this.possedeFacebook
    this.tabs[3].possedeRS = this.possedeGMB
    this.tabs[4].possedeRS = this.possedeLinkedIn

    if (this.$route.params.linkSocialPosts === true) {
      this.fromNewPost = true
    }
    getPostById(this.$route.params.id).then((post) => {
      this.post = post
      // for Test: CLAP VIDEO
      // this.post.url_clap = 'https://download.clap.video/2023/9/lJ9VutCT8YH9unzy7DG0a.mp4'
      if (post.url_clap) {
        if (this.getHasUrlClapVideo.length === 0) {
          this.$store.commit('storeClap/setUrlClap', { id: post.id, url_clap: post.url_clap })
        }
      } else {
        this.$store.commit('storeClap/setClapInProgress', false)
      }
      if (!this.hasPostClapVideo) {
        this.$store.commit('storeClap/setPostStatus', post)
      }

      if (this.post.type === 'error') {
        this.loading = false
        return false
      }

      this.formatPostBooleanValues(post)
      this.$store.dispatch('caption/loadCaptions', {
        universe: this.universe,
        annonceId: post.id,
        bienVendu: false
      })
      this.loading = false
    })
  },
  created () {
    // si on fait un changement de langue sur une page d'édition, les labels peuvent ne pas avoir le temps de
    // se charger. Le code suivant attend un peu avant d'afficher les components si besoin.
    if (this.$labels === undefined) {
      setTimeout(() => {
        this.labelsLoaded = true
      }, 4000)
    } else {
      this.labelsLoaded = true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.redirectToList && this.redirect === false) {
      const answer = window.confirm(this.$t('posts.edit.alertBeforeLeave'))
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>
